import { createStore } from 'satcheljs';

export const enum PremiumExperienceType {
    None = 'None',
    PremiumTravel = 'PremiumTravel',
    PremiumDomainConnect = 'PremiumDomainConnect',
    NonPremiumTravelUpsell = 'NonPremiumTravelUpsell',
    NonPremiumDomainConnectUpsell = 'NonPremiumDomainConnectUpsell',
}

export interface PremiumTravelStore {
    isInit: boolean;
    premiumExperienceType: PremiumExperienceType;
    isActivated: boolean;
    savings: string;
}

const premiumTravelStore: PremiumTravelStore = {
    isInit: false,
    premiumExperienceType: PremiumExperienceType.None,
    isActivated: false,
    savings: '',
};

export const store = createStore<PremiumTravelStore>('premiumTravelStore', premiumTravelStore)();
